<template>
  <div class="cash">
    <Header msg='奖金提现' />
    <div class="cash-header">
      <p class="header-title">总提成(元）</p>
      <p class="header-price">¥ <i class="text-yellow">{{pageData.total_price || '0.00'}}</i></p>
    </div>
    <div class="cash-show flex" @click="toshowCashlist">
      <div class="cashShow-item">
        <p>冻结金额(元)</p>
        <p>{{pageData.freeze_price || '0.00'}}</p>
      </div>
      <div class="cashShow-item">
        <p>已提金额(元)</p>
        <p>{{pageData.raise_price || '0.00'}}</p>
      </div>
      <div class="cashShow-item">
        <p>可提金额(元)</p>
        <p>{{pageData.price || '0.00'}}</p>
      </div>
    </div>

    <!-- <Navbar :selected.sync="selected" :selecteData="selecteData"/> -->

    <!-- <div class="cash-pay" v-show="selecteData[selected].id === 1 || selecteData[selected].id === 2">

            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>姓名</span>
                    <input type="text" placeholder="请输入您的真实姓名" v-model="uname"/>
                </div>
            </div>

            <div class="per-line" v-if="selecteData[selected].id === 1">
                <div class="flex flex-j-c-sb">
                    <span>微信号</span>
                    <input type="text" placeholder="请输入您的微信号" v-model="Wxnum"/>
                </div>
            </div>

            <div class="per-line" v-if="selecteData[selected].id === 2">
                <div class="flex flex-j-c-sb">
                    <span>支付宝号</span>
                    <input type="text" placeholder="请输入您的支付宝号" v-model="Alinum"/>
                </div>
            </div>
      </div>

      <div class="cash-unpay" v-show="selecteData[selected].id === 3">

            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>持卡人</span>
                    <input type="text" placeholder="请输入持卡人真实姓名" v-model="uname"/>
                </div>
            </div>

            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>卡号</span>
                    <input type="number" placeholder="请输入银行卡号" v-model="unPaynum" @blur="checkBankNum()"/>
                </div>
            </div>

            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>银行名称</span>
                    <input type="text" placeholder="请输入银行名称" v-model="unPaytype"/>
                </div>
            </div>

            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <span>开户网点</span>
                    <input type="text" placeholder="请输入开户网点" v-model="unPayAddress"/>
                </div>
            </div>
      </div> -->

    <!-- 提现金额 -->
    <div class="cash-money">
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <span>姓名</span>
          <input type="text" placeholder="请输入您的真实姓名" v-model="uname" />
        </div>
      </div>
    </div>
    <div class="cash-money">
      <div class="per-line">
        <div class="flex flex-j-c-sb">
          <span>提现金额</span>
          <input type="number" placeholder="请输入提现金额" v-model="cashMoney" />
        </div>
      </div>
    </div>

    <mt-button @click.native="CashClick" size="large" :class="btnJudge ? 'bgColor':''">立即提现</mt-button>

    <div class="fill-form"><a href="https://jinshuju.net/f/jkSZ61">点击填写账号信息</a></div>

    <!-- <div class="bottom-tips">系统收到您的提现申请后，将在每周一、四晚审核，周二、五处理提现申请。请留意查收。</div> -->
    <div class="bottom-tips">{{tips}}</div>

  </div>
</template>

<script>
  import Header from '@/components/Header.vue';
  import Navbar from '@/components/Navbar.vue';
  import DataNull from '@/components/DataNull';
  import {
    CashWithdrawal,
    CashSubmit,
    GetCashList
  } from '@/api';
  import {
    Toast
  } from 'mint-ui';
  var BIN = require('bankcardinfo');

  export default {
    name: 'Cash',
    components: {
      Header,
      Navbar,
      DataNull
    },
    data() {
      return {
        selected: 0, // Navbar索引
        // selecteData: [{id: 1, name: '微信', num: 0}, {id: 2, name: '支付宝', num: 0}, {id: 3, name: '银行卡', num: 0}],
        selecteData: [{
          id: 2,
          name: '支付宝',
          num: 0
        }, {
          id: 3,
          name: '银行卡',
          num: 0
        }], // Navbar数据
        uname: '', // 姓名
        Wxnum: '', // 微信号
        Alinum: '', // 支付宝号
        unPaynum: '', // 银行卡号
        unPaytype: '', // 银行名称
        unPayAddress: '', // 开户网点
        cashMoney: '', // 提现金额
        pageData: '', // 页面数据
        btnJudge: false, // 提交按钮

        page: 1, // x
        cashData: [], // x
        loading: true, // x
        shownull: false, // x
        isShowMask: false, // x
        cashJudge: '', // x

        fillInData: {}, // 自动填充数据
        tips: '' // 提示词
      }
    },
    watch: {},
    created() {
      this.getCashData();
      /** ------------------------------------自动填充相关--------------------------------------------- */
      this.uname = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData')).pdName :
        '';
      this.Alinum = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData'))
        .pdAlinum : '';
      this.unPaynum = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData'))
        .pdUnPaynum : '';
      this.unPaytype = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData'))
        .pdUnPaytype : '';
      this.unPayAddress = localStorage.getItem('cww_FillInData') ? JSON.parse(localStorage.getItem('cww_FillInData'))
        .pdUnPayAddress : '';
      this.fillInData = JSON.parse(localStorage.getItem('cww_FillInData')) || {}
      /** ------------------------------------自动填充相关--------------------------------------------- */
    },
    mounted() {
      this.tips = window._cwwConfigData ? window._cwwConfigData.cashTips : '提现申请已经升级为【微信零钱到账】，系统收到你的提现申请后将在7个工作日处理'
    },

    methods: {
      // 提现页面数据
      getCashData() {
        CashWithdrawal().then(res => {
          this.pageData = res.data;
        })
      },
      // 提现
      submitCash(data) {
        if (this.btnJudge) return false;
        this.btnJudge = true;
        CashSubmit(data).then(res => {
          if (res.code === 0) {
            Toast({
              message: `您提现${data.cash}元已提交申请，请返回填写账号信息！`,
              className: 'iconfont icon-dui'
            });
            this.$router.go(-1);
          } else {
            Toast({
              message: res.msg,
              className: 'iconfont icon-close'
            });
          }
          this.btnJudge = false;
        })
      },
      // 提现按钮
      CashClick() {
        let params = {},
          judge = true;
        params.pay_type = 0;
        if (!this.uname) {
          Toast({
            message: '请输入姓名',
            className: 'iconfont icon-close'
          });
          judge = false;
          return false;
        } else {
          params.name = this.uname;
        };
        // switch (this.selecteData[this.selected].id) {
        //   case 1:
        //     params.pay_type = '0';
        //     if (!this.Wxnum) {
        //       Toast({message: '请输入微信号', className: 'iconfont icon-close'});
        //       judge = false;
        //       return false;
        //     } else { params.mobile = this.Wxnum; };
        //     break;
        //   case 2:
        //     params.pay_type = '1';
        //     if (!this.Alinum) {
        //       Toast({message: '请输入支付宝账号', className: 'iconfont icon-close'});
        //       judge = false;
        //       return false;
        //     } else { params.mobile = this.Alinum; };
        //     break;
        //   case 3:
        //     params.pay_type = '2';
        //     if (!this.unPaytype) {
        //       Toast({message: '请输入开户银行', className: 'iconfont icon-close'});
        //       judge = false;
        //       return false;
        //     } else if (!this.unPayAddress) {
        //       Toast({message: '请输入开户网点', className: 'iconfont icon-close'});
        //       judge = false;
        //       return false;
        //     } else { params.bank_name = this.unPaytype + '#' + this.unPayAddress; };
        //     if (!this.unPaynum) {
        //       Toast({message: '请输入银行卡号', className: 'iconfont icon-close'});
        //       judge = false;
        //       return false;
        //     } else { params.bank_number = this.unPaynum; };
        //     break;
        //   default:
        //     break;
        // }
        /** ------------------------------------自动填充相关--------------------------------------------- */
        this.fillInData.pdName = this.uname;
        if (this.Alinum) {
          this.fillInData.pdAlinum = this.Alinum;
        };
        if (this.unPaytype && this.unPayAddress) {
          this.fillInData.pdUnPaytype = this.unPaytype;
          this.fillInData.pdUnPayAddress = this.unPayAddress;
        };
        if (this.unPaynum) {
          this.fillInData.pdUnPaynum = this.unPaynum;
        };
        localStorage.setItem('cww_FillInData', JSON.stringify(this.fillInData));
        /** ------------------------------------自动填充相关--------------------------------------------- */

        if (!this.cashMoney) {
          Toast({
            message: '请输入提现金额',
            className: 'iconfont icon-close'
          });
          judge = false;
          return false;
        } else {
          let showTips = Number(this.cashMoney) <= 0 ? '提现金额不能小于1元' :
            Number(this.cashMoney) > Number(this.pageData.price) ? '提现金额不能大于可提现金额' : '';
          if (Number(this.cashMoney) < 1 || Number(this.cashMoney) > Number(this.pageData.price)) {
            Toast({
              message: showTips,
              className: 'iconfont icon-close'
            });
            judge = false;
            return false
          } else {
            params.cash = this.cashMoney;
          }
        };
        if (judge) {
          // console.log(params)
          this.submitCash(params);
        }
      },
      // 自动匹配银行
      checkBankNum() {
        BIN.getBankBin(String(this.unPaynum))
          .then((data) => {
            // console.log(data)
            this.unPaytype = data.bankName;
          })
          .catch(function(err) {
            // console.log(err);
            Toast({
              message: err
            });
          })
      },
      // 跳转提现详情
      toshowCashlist() {
        // this.isShowMask = true;
        // this.getCashList(1);
        this.$router.push({
          path: '/CashDetails'
        })
      },
    }
  }
</script>
<style lang='less' scoped>
  .cash {
    width: 100%;
    min-height: 100vh;
    padding: 0 0 0.68rem;
    position: relative;

    input {
      height: 0.48rem;
    }

    .cash-header {
      border-top: 0.45rem solid #f6f6fa;
      background: white;
      padding: 0.3rem 0.16rem;

      .header-title {
        color: #666666;
        font-size: 0.12rem;
      }

      .header-price {
        margin-top: 0.15rem;
        font-size: 0.18rem;

        i {
          font-size: 0.28rem;
        }
      }
    }

    .cash-show {
      border-top: 1px solid #eeeeee;
      padding: 0.18rem 0.16rem;
      background: white;

      &>:last-child {
        border: none !important;
      }

      .cashShow-item {
        width: 33.3%;
        height: auto;
        border-right: 1px solid #eeeeee;
        font-size: 0.12rem;
        color: #666666;

        &>:last-child {
          font-size: 0.18rem;
          color: #000000;
          margin-top: 0.1rem;
        }
      }
    }

    .Navbar {
      margin: 0.1rem 0;
    }

    .cash-pay,
    .cash-money,
    .cash-unpay {
      padding: 0 0.16rem;
      background: white;

      &>:last-child {
        border: none;
      }
    }

    .cash-money {
      margin-top: 0.1rem;
    }

    .cash-details {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 6px;
      width: 90%;
      height: auto;
      max-height: 60vh;
      background: white;
      overflow: scroll;

      .detail-title {
        font-size: 0.16rem;
        font-weight: bold;
        width: 100%;
        margin: 0.1rem 0;
      }

      .detail-item {
        padding: 0.1rem 0.2rem;
        border-top: 0.5px solid #eee;
        flex-direction: column;

        .detail-item-price {
          font-size: 0.18rem;
          color: #FABD01;
          width: 100%;
          text-align: left;
        }

        .detail-item-msg {
          margin-top: 0.1rem;

          p {
            color: #666;
          }

          p:last-child {
            color: #999;
          }
        }
      }
    }

    .cashMask-close {
      width: 0.3rem;
      height: 0.3rem;
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
    }

    .detail-item-status {
      width: 30%;
      color: #666;
      text-align: right;
    }

    .fill-form {
      text-align: center;
      line-height: 40px;
      background-color: #4e6ef2;
      width: 90%;
      margin: .3rem auto;
      border-radius: .2rem;
      height: .4rem;

      a {
        font-size: 18px;
        color: white;
      }
    }

    .bottom-tips {
      background: rgba(0, 0, 0, 0.3);
      color: white;
      font-size: 0.12rem;
      text-align: left;
      padding: 0.1rem;
      position: absolute;
      bottom: 0;
      left: 0;
      // text-indent:2em;
    }
  }
</style>
